import React from 'react';
import { InGameSetIn } from './../features/InGame';

const InGame = props => {
  return <InGameSetIn to="/prolympic" />;
};

export default InGame;

